import { stripPromotionsPayload } from '~/utils/stripPromoDetails'

export const usePromotionData = () => {
  const { sanitize } = useUtils();

  const dateToISOLocale = (date) => {
    return date.toLocaleString('sv').replace(' ', 'T');
  }

  const transform = (response) => {
    const strippedResponse = stripPromotionsPayload(response || {});

    if (strippedResponse.featuredPromo && Array.isArray(strippedResponse.featuredPromo) && strippedResponse.featuredPromo.length > 0) {
      // Find active promotions
      const activePromotions = strippedResponse.featuredPromo.filter((promo) => {
        const currentDate = new Date(); // Current date in user's local time zone
      
        // New function dateToISOLocale added to convert date to ISO locale
        const startDate = promo.attributes.discountBannerStartDateTime;
        const endDate = promo.attributes.discountBannerEndDateTime;        
        const currentLocaleDate = dateToISOLocale(currentDate);
      
        return currentLocaleDate >= startDate && currentLocaleDate <= endDate;
      });
      
      // Check if there are multiple promotions with the same priority
      const uniquePriorities = Array.from(new Set(activePromotions.map((promo) => promo.attributes.priority)));
      if (activePromotions.length > 1 && uniquePriorities.length === 1 || activePromotions.length < 1) {
        // Clone the original response to avoid mutating it
        const newResponse = { ...strippedResponse };

        // Replace the `featuredPromo` array with an empty array
        newResponse.featuredPromo = [];

        // Return the transformed response
        return {
          promotion: sanitize(newResponse),
        };
      } else if (activePromotions.length > 0) {
        // Sort promotions by priority
        activePromotions.sort((a, b) => b.attributes.priority - a.attributes.priority);

        // Clone the original response to avoid mutating it
        const newResponse = { ...strippedResponse };

        // Replace the `featuredPromo` array with the highest priority active promotion
        newResponse.featuredPromo = [activePromotions[0]];

        // Return the transformed response
        return {
          promotion: sanitize(newResponse),
        };
      }
    }
    // No active promotions or only one promotion, return the original response
    return {
      promotion: sanitize(strippedResponse),
    };
  };

  /** Client-only fetch for View Details HTML (skips Nuxt payload serialization). */
  const fetchPromotionDetail = async (id, source = 'promo') => {
    return await $fetch('/api/promotion-detail', {
      method: 'GET',
      query: { id, source },
    })
  };

  const getPromotion = async (_deep = true) => {
    const url = `/api/promotion`;

    return await useFetch(url, {
      method: 'GET',
      transform: transform,
    });
  };

  const getPromoBannerSettings = async () => {
    const url = `/api/promo-banner`;

    return await useFetch(url, {
      method: 'GET',
    });
  };

  return {
    getPromotion,
    getPromoBannerSettings,
    fetchPromotionDetail,
  };
};

